import React, { useState, useEffect } from "react";
import styles from "@/components/CustomComponents/EditionPattern/index.module.scss";
import Image from "next/image";
import Modal from "@/components/CustomComponents/EditionPattern/Modal";

const EditionPattern = props => {
  const { patternData } = props;
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const { heading = "", images = [] } = patternData || {};

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <div className={styles.wrapper}>
      <div className="w-full max-[999px]:px-2 overflow-visible">
        <div className="w-full flex flex-col justify-center min-w-0! overflow-visible">
          <div className="koh-meterial-category">
            <p className="koh-material-title text-xl md:text-2xl">{heading}</p>
          </div>

          <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-[1.6px]">
            {images.map((item, index) => (
              <div
                key={index}
                onClick={() => {
                  setOpen(true);
                  setModalData(item);
                }}
                className="koh-meterial-category-items hover:shadow-[0_0_6px_0_rgba(0,0,0,0.6)] transition-shadow duration-300 cursor-pointer group"
              >
                <Image
                  src={item.fields.imageUrl}
                  alt={item.fields.alt}
                  width={0}
                  height={0}
                  className="w-full h-auto block object-cover"
                />
                <div className="p-2 flex flex-col justify-items-center pt-2 text-[#232323] text-[14px]">
                  <p className="koh-color-palette-panel-caption">
                    {item.fields.name}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {open ? (
        <Modal open={open} setOpen={setOpen} modalData={modalData} />
      ) : null}
    </div>
  );
};

export default EditionPattern;
